import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThemodelsresourceComponent } from './simple-icons-themodelsresource.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThemodelsresourceComponent ],
    exports:      [ SimpleIconsThemodelsresourceComponent ],
    bootstrap:    []
})
export class SimpleIconsThemodelsresourceModule {}
